module.exports = __webpack_public_path__ + "img/tiktok-logo.d77c30e7.png";